import React, { useContext, useEffect, useState } from 'react';
import { PetWeight, useGetPetWeightDetails } from '@/features/payment/api/petWeights';
import { WeightPriceConfiguration } from '@/features/services/components/PetWeightConfig';
import { useAuth } from '@/lib/auth';
import Utils from '@/utils/util';
import { showNotification } from '@/utils/notificationUtils';
import { UserContext } from '@/routes';
export type PetWeightProps = {
  selectedSize?: string;
  onChange: (wc: PetWeight) => void;
  readOnly?: boolean;
  availableSizeConfiguration?: WeightPriceConfiguration | undefined | null;
};

export default function PetWeightSelection({
  readOnly,
  selectedSize,
  availableSizeConfiguration,
  onChange,
}: PetWeightProps) {
  const userContext = useContext(UserContext);
  const { user } = useAuth();
  const [petWeightConfigurations, setPetWeightConfigurations] = useState<PetWeight[]>();
  const [selectedPetWeight, setSelectedPetWeight] = useState<PetWeight>();
  const petSizes =
    user && user.activeLocation && user.activeLocation?.petSizes
      ? user.activeLocation?.petSizes
      : userContext?.business?.petSizes;
  useEffect(() => {
    //console.log('on changes  of pet sizes', availableSizeConfiguration);
    getPetConfigurations();
  }, [availableSizeConfiguration]);

  useEffect(() => {
    if (selectedSize && petWeightConfigurations) {
      const filteredSize = petWeightConfigurations.find((pwc) => pwc.key === selectedSize);
      setSelectedPetWeight(filteredSize);
    }
  }, [selectedSize, petWeightConfigurations]);

  const getPetConfigurations = async () => {
    if (petSizes) {
      const pwCon: PetWeight[] = [];

      for (const [key, value] of Object.entries(petSizes)) {
        const pw: PetWeight = { ...value, key: key };
        pwCon.push(pw);
      }

      let defaultSizeConfig = null;
      if (availableSizeConfiguration) {
        for (let i = 0; i < Utils.DEFAULT_PET_SIZE_RANKINGS.length; i++) {
          const defaultSize = Utils.DEFAULT_PET_SIZE_RANKINGS[i];
          const defaultPrice = parseFloat(
            availableSizeConfiguration[defaultSize as keyof typeof availableSizeConfiguration]
              .price as string
          );
          if (defaultPrice > 0) {
            defaultSizeConfig = defaultSize;
            break;
          }
        }
      }
      const defaultKey = defaultSizeConfig ? defaultSizeConfig : Utils.DEFAULT_PET_SIZE;
      const filteredConfig = pwCon.find((pw) => pw.key === defaultKey);
      if (!selectedSize && filteredConfig) {
        handleSelectWeight(filteredConfig);
      }

      setPetWeightConfigurations(pwCon);
    }
  };

  const handleSelectWeight = (petWeight: PetWeight) => {
    setSelectedPetWeight(petWeight);
    onChange(petWeight);
  };

  return (
    <>
      {petWeightConfigurations &&
        petWeightConfigurations.map((item) => {
          const asc =
            availableSizeConfiguration &&
            availableSizeConfiguration[item.key as keyof typeof availableSizeConfiguration];

          const hasPrice = parseFloat(asc?.price as string) > 0;
          return (
            <div
              className={`pet-detail-card ${readOnly ? 'read' : ''} ${
                item.key === selectedPetWeight?.key ? 'active' : ''
              } ${availableSizeConfiguration && !hasPrice ? 'disabled-cursor' : ''}`}
              onClick={() => {
                if (
                  !readOnly &&
                  ((availableSizeConfiguration && hasPrice) || !availableSizeConfiguration)
                ) {
                  handleSelectWeight(item);
                }
                if (availableSizeConfiguration && !hasPrice) {
                  showNotification({
                    type: 'info',
                    title: 'You cannot select this pet size for the selected service',
                  });
                }
              }}
            >
              <div className="pet-detail-info">
                <div className="pet-detail-name">{item.name}</div>
                <div className="pet-detail-desc">{item.description}</div>
              </div>
            </div>
          );
        })}
    </>
  );
}
